import React, { useEffect } from "react";

import { s360ConfigService } from "../../Services/S360Config";

function CloseMessage(props) {

  useEffect(() => {
    sessionStorage.removeItem("agentConnected");
    sessionStorage.removeItem("agentWaiting");
    sessionStorage.removeItem("agentName");
    

    return () => {
      if (s360ConfigService?.config?.hideIcon) {
        sessionStorage.removeItem("isLoggedIn");
      }
      sessionStorage.removeItem("agentConnected");
      sessionStorage.removeItem("agentWaiting");
    }
  }, []);

  const isFullScreen = localStorage.getItem("openInFullScreen")
  return (
    <div className={`s360-closeConversation-close-container${isFullScreen ? "-fs" : ""}`}>
      {/* <div className="closemessage-cross-icon"> 
        <svg
          onClick={props.startNewConversation}
          width="14" height="14" viewBox="0 0 14 14" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13 1L1 13"
            stroke="#333333"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1 1L13 13"
            stroke="#333333"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg></div> */}
      <div className={`s360-close-conversation-text${isFullScreen ? "-fs" : ""}`}>
        <p>{props.message.message.text.toString()}</p>
      </div>
      <div className={`s360-close-conversation-button${isFullScreen ? "-fs" : ""}`}>
        <button
          onClick={props.startNewConversation}
          style={{
            ...props.config?.customDesign?.closeConversationButton,
          }}
        >
          Start New Conversation
        </button>
      </div>
    </div>
  );
}

export default CloseMessage;
